import React, { Component, PureComponent } from "react";
import _ from "lodash";
import {
  WithStyles,
  withStyles,
  Grid,
  Typography,
  Link,
  Button,
  Dialog,
} from "@material-ui/core";
import {
  TestSeriesCoursePlan as testSeriesCoursePlan,
  TestDetail,
  Template,
  CourseBasicDetails,
} from "../types/interfaces/CourseBasicDetails";
import PerfectScrollbar from "react-perfect-scrollbar";
import { format } from "date-fns";
import classNames from "classnames";
import TestDetailCard from "./TestDetailCard";
import BulkAddTestPopUp from "./BulkAddTestPopUp";
import courseManagementServices from "../service/courseManagementServices";
import { Package } from "../types/interfaces/CourseBasicDetails";
import { getFormattedDates } from '../components/treeComponents/helper';
import { coursePlanStyle } from "../styles";
import { CourseTypes } from "../types/enums/CourseTypes";
import dateService from "../../../components/common/services/dateService";
import {createErrorSheet, getDeafultTestDetail} from '../helpers/helpers';
import * as XLSX from 'xlsx';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkIfTestAlreadyAddedInTestSeries } from '../components/coursePlan/addTestDialog/helpers/checkAddedTest'
import { showMsg } from "../../course/actions/loaderAlert";
interface Props extends WithStyles<typeof coursePlanStyle> {
  classes: any;
    transferToParent: (testSeriesData: testSeriesCoursePlan) => void;
  packageData: Package;
  requestCoursePlan: testSeriesCoursePlan;
  isPreviewScreen:boolean,
  basicDetail:CourseBasicDetails,
  showMsg: Function
}

interface State {
  coursePlan: testSeriesCoursePlan;
  showBulkTestPopUp: boolean;
  templates:Template []
}

class TestSeriesCoursePlan extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      coursePlan: props.requestCoursePlan,
      showBulkTestPopUp: false,
      templates:[]
    };
    // this.handleChange = _.debounce(this.handleChange, 200);
  }

  handleChange = () => {
    // const coursePlan = { ...this.props.requestCoursePlan};
    const {coursePlan}=this.state;
    const newCoursePlan={...coursePlan};
    this.props.transferToParent(newCoursePlan);
  };
  handleBulkTestBttn = () => {
    this.setState({
      showBulkTestPopUp: !this.state.showBulkTestPopUp,
    });
  };
  componentDidMount = () => {
      // this.getPackageTemplates();
      // this.setState({coursePlan: this.props.requestCoursePlan});  
  };
  componentDidUpdate(prevProps: Props, prevState: State) {
    if(prevProps.requestCoursePlan!==this.props.requestCoursePlan){
      this.setState({coursePlan:{...this.props.requestCoursePlan}})
    }
    //  if(this.state.coursePlan!==this.props.requestCoursePlan &&
    //           prevState.coursePlan!==this.state.coursePlan){
    //             console.log("Change in state");
    //   this.handleChange();
    // }
  //  if(prevProps.packageData!==this.props.packageData){
  //     this.getPackageTemplates();
  //   }
  }

  validateTestIds = async (testDetails: Array<any>, courseId: string) => {
    const { packageData } = this.props;
    
    const reqParams = {
      tests: testDetails,
      courseId: courseId,
      packageId: _.get(packageData, "_id", ""),
      // testType: 'phase'
    };
    try {
     const res= await courseManagementServices.validateTestIds(reqParams);
       return res;
    } catch (err) {
      console.log("Error on validate TestIds", err);
    }
  };

  createTestNameAndIdMap = (validTests: any) => {
    const testNameIdMap: any = {};
    validTests.map((test: any) => {
      const { testId, _id } = test;
      testNameIdMap[testId] = _id;
    });
    return testNameIdMap;
  };

  getQuestionCount = (test:any, validTests: any[]) => {
    let questionsCount;
    for(let i = 0; i < validTests.length; i++){
      if(validTests[i].testId === test.testId)
      {
        questionsCount = validTests[i].questionsCount;
        break;
      }
    }
    return questionsCount;
  }

  handleAddTests =async (testIdsToCheck: any, testDetails: TestDetail[], courseId: string) => {
    const res =await this.validateTestIds(testDetails, courseId);
    
    // console.log("RESPONSE IN ADDTEST",res);
    const validTests = _.get(res, "validTests", []);
    const inValidTests = _.get(res, "invalidTests", []);
    
    if (inValidTests.length == 0) {
      const testNameIdMap = this.createTestNameAndIdMap(validTests);
      const { coursePlan } = this.state;
      const{packageData}=this.props;
      const newCoursePlan = { ...coursePlan };
      const newTestSeries = [...newCoursePlan.testSeries ];
      const{courseDetails}=packageData;
      const packageCourseId = _.get(packageData, "courseDetails[0].courseId", "");
      
      let anyDuplicateTest = false;
      testDetails.forEach((testDetail: TestDetail) => {
        let testId = _.get(testDetail, "testId");
        const questionCountFromAPI = this.getQuestionCount(testDetail, validTests)
        let maxAttempts=_.get(testDetail,"maxAttempts");
        let questionsCount = testNameIdMap[testId] ? questionCountFromAPI : _.get(testDetail, 'questionsCount');
        if (testNameIdMap[testId]) {
          testId = testNameIdMap[testId];
        }else{
          testId="000000000000000000000000"
        }
       let newTestDetail={
                ...testDetail,
                 testId,
                 courseId : courseId || packageCourseId,
                 maxAttempts,
                 questionsCount
               }  
        const isTestAlreadyAdded = checkIfTestAlreadyAddedInTestSeries(coursePlan.testSeries, newTestDetail);
        const isTestAlreadyAddedInNewTestSeries = checkIfTestAlreadyAddedInTestSeries(newTestSeries, newTestDetail);
        if(!isTestAlreadyAdded) {
          if(!isTestAlreadyAddedInNewTestSeries) {
            newTestSeries.push(newTestDetail);
          } else {
            anyDuplicateTest = true;
          }
        } else {
          anyDuplicateTest = true;
        }
      });

      if(anyDuplicateTest){
        this.props.showMsg('Test already exists in course', 'error')
      }

      newCoursePlan.testSeries = newTestSeries;
      newCoursePlan.totalTests = newTestSeries.length;
      this.setState({ coursePlan: newCoursePlan },()=>{this.handleChange()});
    } else {
       const sheetResponse:any=[];
       const testNameMap:any={};
       inValidTests.forEach((test: any) => {
        const { testId} = test;
        testNameMap[testId] = test;
        sheetResponse.push(test);
      });
      // testDetails.forEach((testDetail: any) => {
      //   let testId = _.get(testDetail, "testId");
      //   if(testNameMap[testId]){
      //      testDetail.errorMessage=testNameMap[testId].errorMessage;   
      //   }
      //   sheetResponse.push(testDetail);
      // });
       createErrorSheet(sheetResponse,'ScheduleTestSheet.xlsx');
    }
  };
  handleAddExistingTest=(testSeries: TestDetail[])=>{
    // console.log({testSeries});
    const { coursePlan } = this.state;
    const{packageData}=this.props;
    const newCoursePlan = { ...coursePlan };
    let newTestSeries = [...newCoursePlan.testSeries]; 
    let combinedtestSeries = []
    combinedtestSeries.push(...newTestSeries, ...testSeries);
    newCoursePlan.testSeries=combinedtestSeries;
    newCoursePlan.totalTests=combinedtestSeries.length; 
    this.setState({coursePlan:newCoursePlan},()=>{this.handleChange()});
  }
  deleteTest=(index:number)=>{
    const newCoursePlan  = {...this.state.coursePlan};
    let  newTestSeries  = [...newCoursePlan.testSeries];
     newTestSeries.splice(index,1);
    //  Add new Test by default if user delete the last single test also.
     if(newTestSeries.length==0){
      const firstCourseId = _.get(this.props.packageData,"courseDetails[0].courseId", "");
      const testDetail: TestDetail = getDeafultTestDetail();
      testDetail.name = `Test-${1}`;
      testDetail.courseId=firstCourseId;
      newTestSeries.push(testDetail);
     }
     newCoursePlan.testSeries=newTestSeries;
     newCoursePlan.totalTests=newTestSeries.length;
    this.setState({coursePlan:newCoursePlan},()=>{this.handleChange()});
  }

  handleTestDetailChange=(coursePlan:testSeriesCoursePlan)=>{
    this.setState({coursePlan},()=>{this.handleChange()});
  }

  handleTestVisibilityToggle = (contentItem: any, isHidden: any) => {
    const newCoursePlan  = {...this.state.coursePlan};
    const  newTestSeries  = [...newCoursePlan.testSeries];
    newTestSeries.forEach((test)=>{
      if (test.testId === contentItem.testId ) {
        test.isHidden = isHidden;
      }
    })
    newCoursePlan.testSeries=newTestSeries;
    this.setState({coursePlan:newCoursePlan},()=>{this.handleChange()});
  };

  render() {
    const { packageData,isPreviewScreen, basicDetail} = this.props;
    const { coursePlan, showBulkTestPopUp,templates } = this.state;
    const {courseDetails } = packageData;
    const { testSeries } = coursePlan;
    const startDate=_.get(basicDetail,"startDate.value",'');
    const expiryDate=_.get(basicDetail,"endDate.value",'');
    const showTestVisibility=_.get(coursePlan,"displaySettings.showTestVisibility",false);
    return (
      <>
       <div className='course-plan'>
          <div className='course-plan-heading'>
            <span>
              <h4 className="coursePlanHeading">Course Plan</h4>
              {startDate && expiryDate &&
               <>
                <p className="dateRange">
                {format(new Date(startDate||Date.now()), "dd MMM yyyy")} <span> to </span> 
                {format(new Date(expiryDate||Date.now()), "dd MMM yyyy")}
               </p>
               </>}
            </span>
            {!isPreviewScreen&&<div>
            <Button variant='contained' color='primary' onClick={this.handleBulkTestBttn}>Bulk Add Tests
            </Button>
            </div>}
            {showBulkTestPopUp &&(
           <BulkAddTestPopUp
             open={showBulkTestPopUp}
             onClose={this.handleBulkTestBttn}
             onDone={this.handleAddTests}
             templates={templates}
             addExistingTest={this.handleAddExistingTest}
           />
          )}
          </div>
          <div />
          <div> 
        <Grid>
          {testSeries && testSeries.map((testDetail: TestDetail, index: number) => {
            // const name=_.get(testDetail,"name",`Test-${index}`);
            //     testDetail.name=name;
            return (
                <TestDetailCard 
                testDetail={testDetail} 
                index={index}
                courseDetails={courseDetails}
                handleDeleteCard={this.deleteTest}
                transferToParent={this.handleTestDetailChange}
                coursePlan={coursePlan}
                isPreviewScreen={isPreviewScreen}
                showTestVisibility={showTestVisibility}
                handleTestVisibilityToggle={this.handleTestVisibilityToggle}
                />
            )
          })}
        </Grid>
        </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    basicDetail: state.courseMangementData.courseManagementReducer.testSeries.basicDetail,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showMsg
    },
    dispatch
  );


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(coursePlanStyle)(TestSeriesCoursePlan));
